<template>
  <v-card
      class="mx-auto pa-5 overflow-visible"
      outlined
  >
    <div class="chart">
      <div class="chart-title chart-title--multiLine display-1">
        BIỂU ĐỒ SỐ PHÚT TB/ NV/ CA
      </div>
      <div class="chart-content">
        <div class="chart-item">
          <span class="font-weight-bold">Kho T :</span>
          <span class="chart-bg chart-bg--male"></span>
        </div>
        <div class="chart-item">
          <span class="font-weight-bold">Kho C :</span>
          <span class="chart-bg chart-bg--female"></span>
        </div>
      </div>
    </div>
    <chartist
      :data="multipleLine.data"
      :options="multipleLine.options"
      type="Line"
      style="max-height: 300px;"
      class="mt-7 chart-multi chart-fix"></chartist>
  </v-card>
</template>
<script>
  import * as ChartistTooltips from 'chartist-plugin-tooltips';
  export default {
    props: {
      reports: {
        type: Object,
        default: () => {},
      },
      dataChart: {
        type: Object,
        default: () => {},
      }
    },
    created () {
      this.multipleLine.data.series = [
        this.dataChart.tValues.map(d => ({ meta: 'Tổng số phút :', value: d })),
        this.dataChart.cValues.map(d => ({ meta: 'Tổng số phút :', value: d })),
      ]
      Bus.$on('data-chart-filter', (dataChart) => {
        this.dataChartChange = dataChart
        this.getData()
      })
    },
    data() {
      return {
        multipleLine: {
          data: {
            labels: this.dataChart.labels,
            series: [],
          },
          options: {
            low: 0,
            axisY: {
              onlyInteger: true,
            },
            chartPadding: {
              top: 0,
              right: 40,
              bottom: 0,
              left: 0,
            },
            fullWidth: true,
            plugins: [this.$chartist.plugins.tooltip()]
          },
        },
        dataChartChange: {
          labels: [],
          tValues: [],
          cValues: [],
        }
      }
    },
    methods: {
      getData() {
        this.multipleLine.data.series = [
          this.dataChartChange.tValues.map(d => ({ meta: 'Số phút gọi trung bình :', value: d })),
          this.dataChartChange.cValues.map(d => ({ meta: 'Số phút gọi trung bình :', value: d })),
        ]
        this.multipleLine.data.labels = [...this.dataChartChange.labels]
      }
    }
  }
</script>

<style lang="sass">
  .chart-multi
    .ct-series-a .ct-line,
    .ct-series-a .ct-point
      stroke: #00cae3 !important
    svg:not(:root)
      overflow: visible !important
    .ct-grid
      stroke: rgba(0,0,0,.3)
  .chart
    display: flex
    justify-content: space-between
    .chart-content
      display: flex
      .chart-item
        display: flex
        align-items: center
        margin-right: 10px
      .chart-bg
        height: 5px
        width: 15px
        margin-left: 5px
        &.chart-bg--male
          background: #00cae3
        &.chart-bg--female
          background: #f44336

</style>